import './login.css';
import PasswordInput from '../../components/PasswordInput';
// import compass64Px from '../../imgs/compass-64px.png';
// import whiteCompass from '../../imgs/white-compass.png';
import { setAuthToken, login } from "../../services/api";
import { useState } from 'react';
import Input from '../../components/Input';
import { Link, useNavigate } from 'react-router-dom';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
// import { useTheme } from '../../ThemeContext';
// import { THEMES } from '../../constants/theme';

function Login() {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { setMessage } = useUI();
    // const { resolvedTheme } = useTheme();
    // const loginCompassIcon = resolvedTheme === THEMES.DARK ? whiteCompass : compass64Px;

    const navigate = useNavigate();

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    async function authenticate(e) {
        function isAuthValid() {
            if (!email) {
                setMessage({ type: 'warning', text: 'O e-mail não foi preenchido' });
                return false;
            }

            if (!password) {
                setMessage({ type: 'warning', text: 'A palavra-passe não foi preenchida' });
                return false;
            }

            return true;
        }

        e.preventDefault();

        if (!isAuthValid())
            return;
        
        setLoading(true);

        const data = {
            email: email,
            password: password
        };

        await login('/user/authenticate', data, false, setMessage,
            (response) => {
                setAuthToken(response.data.token, navigate);
            },
            (err) => {
                handleErr(setMessage, `Falha ao acessar a conta: ${err}`);
            },
            () => {
                setLoading(false);
            }
        )
    }

    return (
        <div className='main-container'>
            <div id='login-header' className='container'>
                {/* <img src={loginCompassIcon} alt='logo' /> */}

                <div>
                    <h2>Bem-vindo(a) à Bertoli HUB.</h2>
                    <p>A sua jornada no turismo privativo está aqui.</p>
                </div>
            </div>

            <div id="login-container" className='container'>
                <h2>Acesse sua conta</h2>

                <form id="user-login">
                    <Input
                        className='glass-effect-15'
                        type='text'
                        placeholder='E-mail'
                        value={email}
                        disabled={loading}
                        onChange={handleEmailChange}
                        shouldValidate={false}
                        maxLength={256}
                    />

                    <PasswordInput
                        id='password'
                        name='password'
                        className='glass-effect-15'
                        value={password}
                        disabled={loading}
                        onChange={handlePasswordChange}
                        onValidate={() => !!password}
                        shouldValidate={false}
                        maxLength={40}
                        autoComplete='current-password'
                    />

                    <div className='login-utils-container'>
                        <Link to='/recover-password'>
                            Recuperar a palavra-passe
                        </Link>
                    </div>

                    <input
                        id="confirm-button"
                        className={ loading ? 'blocked-button' : "blue-button" }
                        type="submit"
                        value={ loading ? 'Carregando...' : 'Entrar' }
                        disabled={loading}
                        onClick={authenticate}
                    />
                </form>
            </div>
        </div>
    );
}

export default Login;